<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      row-id="inspectionWorkshopCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="checkboxConfig"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>

      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #workshopStatus="{ row }">
        <el-tag v-if="row.workshopStatus === 'Y'" size="mini" type="success">
          {{ $l('table_label_status_valid') || '有效' }}
        </el-tag>
        <el-tag v-else-if="row.workshopStatus === 'N'" size="mini" type="danger">
          {{ $l('table_label_status_invalid') || '无效' }}
        </el-tag>
        <span v-else>{{ row.workshopStatus }}</span>
      </template>

      <template #opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template #displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template #displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>

      <template #empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    checkboxConfig() {
      return {
        highlight: true,
        reserve: true,
        trigger: 'row',
        checkMethod: ({ row }) => `${row.workshopStatus || ''}` !== 'N',
      }
    },
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (menuType === 'edit') this.$emit('edit', data)
      if (menuType === 'delete') this.$emit('delete', data)
    },
    allow(code) {
      return this.$parent?.allow ? this.$parent.allow(code) : true
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      if (!this.$refs.table) return
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
  },
}
</script>

<style lang="scss" scoped></style>

